import { getApi } from '@/stores/api'
import { ReportType } from '@repo/constants'
import { useQuery } from '@tanstack/react-query'
import { atom } from 'jotai'

export const activeReportAtom = atom<{ name: string } | null>(null)

export async function getReports(reportType: ReportType, signal?: AbortSignal) {
  const api = getApi()
  const res = await api.reports.$get({ query: { reportType } }, { init: { signal } })

  const reports = await res.json()
  return reports
}

export async function getReportDetails(id: string, signal?: AbortSignal) {
  const api = getApi()
  const res = await api.reports[':id'].$get({ param: { id } }, { init: { signal } })

  const reportDetails = await res.json()
  return reportDetails
}

export function useReports(reportType: ReportType) {
  return useQuery({
    queryKey: ['reports', reportType],
    queryFn: ({ signal }) => getReports(reportType, signal),
  })
}

export const reportDetailsQueryOptions = (id: string) => ({
  queryKey: ['reportDetails', { id }],
  queryFn: ({ signal }: { signal: AbortSignal }) => getReportDetails(id, signal),
})

export function useReportDetails(id: string) {
  return useQuery(reportDetailsQueryOptions(id))
}
